import { setUserDataInLocalStorage, normalizeLandlordLogoImage } from "_shared/functions";
import {
  SET_SIGNUP_PAYLOAD,
  SET_USER_DATA,
  SET_USER_ROLE,
  SET_ADDRESSES,
  CREAT_USER_ACCOUNT_FAILURE,
  CREAT_USER_ACCOUNT_REQUEST,
  CREAT_USER_ACCOUNT_SUCCESS,
  SET_STEPS,
  VERIFICATION_REQUEST,
  VERIFICATION_FAILURE,
  VERIFICATION_SUCCESS,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
  CLEAR_LOCALSTORAGE_SIGNUP_COMPLETE,
  RESEND_LINK,
  INVITE_LANDLORD_REQUEST,
  INVITE_LANDLORD_SUCCESS,
  INVITE_LANDLORD_FAILURE,
  LOGIN_REQUEST,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  VERIFY_FORGOT_TOKEN_REQUEST,
  VERIFY_FORGOT_TOKEN_SUCCESS,
  VERIFY_FORGOT_TOKEN_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  SET_LOADING,
  SET_PROFILE_IMAGE,
  SET_MY_DETAILS,
  GET_ACCOUNT_DETAILS_REQUEST,
  GET_ACCOUNT_DETAILS_SUCCESS,
  GET_ACCOUNT_DETAILS_FAILURE,
  GET_SUBSCRIPTION_DETAILS_REQUEST,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_DETAILS_FAILURE,
  GET_TICKETING_CUSTOM_SETTINGS_REQUEST,
  GET_TICKETING_CUSTOM_SETTINGS_SUCCESS,
  GET_TICKETING_CUSTOM_SETTINGS_FAILURE,
  NEED_PASSWORD_CHANGE,
  SET_LANDLORD_LOGO_IMAGE,
  SET_CONTACT_DETAILS,
  SET_CUSTOM_DETAILS,
  SET_TICKET_TOKEN_USER_DATA,
  SHOW_TENANT_PROMPT,
  HIDE_TENANT_PROMPT,
  SIGNUP_INCOMPLETE,
  CLEAR_SIGNUP_INCOMPLETE,
} from "./userTypes";
import { removeItemsFromLocalStorage, setItemsToLocalStorage } from "utils";
import { Store, Roles } from "_enums/enums";

const fetchPayload = () => {
  const payload = localStorage.getItem("signupPayload");
  if (payload) {
    return JSON.parse(payload);
  } else {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      contact: "",
      businessName: "",
      postCode: "",
      address: "",
      role: "",
      displayRole: "",
      name: "",
      tenantEmail: "",
      landlordEmail: "",
      trade: "",
      isLoggedIn: false,
      isProfileComplete: false
    };
  }
};

const fetchAddress = () => {
  const payload = localStorage.getItem("address");
  if (payload) {
    return setAddressFormat(JSON.parse(payload));
  } else {
    return [];
  }
};

const setAddressFormat = (json) => {
  const data = [];
  if (json && json.thoroughfares && json.thoroughfares.length)
    for (const element of json.thoroughfares) {
      for (let j = 0; j < element.delivery_points.length; j++) {
        let subName = element.delivery_points[j].sub_building_name;
        let buildingName = element.delivery_points[j].building_name;
        let thoroughfare_name = element.thoroughfare_name;
        let builinNumber = element.delivery_points[j].building_number;
        let thoroughfare_descriptor = element.thoroughfare_descriptor;
        let dependent_locality = json.dependent_locality;
        let organisation_name = element.delivery_points[j].organisation_name;

        let character = "";
        character +=
          organisation_name !== ""
            ? organisation_name.split(" ").reduce((a, b, ind) => {
                if (ind === 0) {
                  a += b[0].toUpperCase() + b.slice(1).toLowerCase().trimStart() + " ";
                } else {
                  a += b[0].toUpperCase() + b.slice(1).toLowerCase() + " ";
                }
                return a;
              }, "")
            : "";
        character += subName !== "" ? subName[0].toUpperCase() + subName.slice(1).toLowerCase() + " " : "";
        character +=
          buildingName !== ""
            ? buildingName.split(" ").reduce((a, b, ind) => {
                if (ind === 0) {
                  a += b[0].toUpperCase() + b.slice(1).toLowerCase().trimStart() + " ";
                } else {
                  a += b[0].toUpperCase() + b.slice(1).toLowerCase() + " ";
                }
                return a;
              }, "")
            : "";
        character += builinNumber !== "" ? builinNumber + " " : "";
        character += thoroughfare_name !== "" ? thoroughfare_name[0].toUpperCase() + thoroughfare_name.slice(1).toLowerCase() + " " : "";
        character +=
          thoroughfare_descriptor !== "" ? thoroughfare_descriptor[0].toUpperCase() + thoroughfare_descriptor.slice(1).toLowerCase() + " " : "";

        character +=
          dependent_locality !== ""
            ? dependent_locality.includes(" ")
              ? dependent_locality.split(" ")[0][0].toUpperCase() + dependent_locality.split(" ")[0].slice(1).toLowerCase() + ", "
              : dependent_locality[0].toUpperCase() + dependent_locality.slice(1).toLowerCase() + ", "
            : "";
        character += json.town[0].toUpperCase() + json.town.slice(1).toLowerCase() + " " + json.postcode;
        data.push(character);
      }
    }
  return data;
};

const getFromLocalStorage = (step) => {
  const payload = localStorage.getItem(step);
  if (payload) {
    return JSON.parse(payload);
  } else return 0;
};

const initialsState = {
  userData: {
    userId: localStorage.getItem(Store.userId) || "",
    contact: localStorage.getItem(Store.contact) || "",
    email: localStorage.getItem(Store.email) || "",
    firstName: localStorage.getItem(Store.firstName) || "",
    jwtToken: localStorage.getItem(Store.token) || "",
    lastName: localStorage.getItem(Store.lastName) || "",
    role: localStorage.getItem(Store.role) || "",
    displayRole: localStorage.getItem(Store.displayRole) || localStorage.getItem(Store.role) || "",
    isLoggedIn: localStorage.getItem(Store.isLoggedIn) === "true" || false,
    isProfileComplete: localStorage.getItem(Store.isProfileComplete) === "true" || false,
    trade: localStorage.getItem(Store.trade) || "",
    businessName: localStorage.getItem(Store.businessName) || "",
    profileImage: localStorage.getItem(Store.profileImage) || "",
    updatedAt: localStorage.getItem(Store.updatedAt) || "",
    createdAt: localStorage.getItem(Store.createdAt) || "",
    landlordBusinessName: localStorage.getItem(Store.landlordBusinessName) || "",
    landlordDisplayRole: localStorage.getItem(Store.landlordDisplayRole) || "",
    landlordLogoImage: normalizeLandlordLogoImage(localStorage.getItem(Store.landlordLogoImage))
  },
  liaisonFirstLogin: {
    firstLogin: localStorage.getItem("liaisonFirstLogin") === "true",
    userId: localStorage.getItem("userId") || "",
  },
  signupIncomplete: { reason: null, userId: null, email: null, role: null, resumeToken: null },
  signupPayload: fetchPayload(),
  addresses: fetchAddress(),
  loading: false,
  step: getFromLocalStorage("step"),
  subStep: getFromLocalStorage("subStep"),
  showStepper: getFromLocalStorage("step") >= 0 && getFromLocalStorage("subStep") !== 0,
  isVerified: JSON.parse(localStorage.getItem("isVerified")),
  isResendLinkSent: JSON.parse(localStorage.getItem("isResendLinkSent")) ? JSON.parse(localStorage.getItem("isResendLinkSent")) : false,
  role: localStorage.getItem("role"),
  isProfileComplete: JSON.parse(localStorage.getItem("isProfileComplete")),
  inviteSent: JSON.parse(localStorage.getItem("inviteSent")) ? JSON.parse(localStorage.getItem("inviteSent")) : false,
  forgotLinkSent: false,
  resetPassword: false,
  subscriptionDetails: {},
  accountDetails: {
    contactDetails: {
      contact: "",
      secondaryContact: "",
      emergencyContact: "",
      contactEmail: ""
    },
    customDetails: {
      logoImage: "",
      mandateCreationMedia: false,
      mandateCompletionMedia: false,
      emailHandle: ""
    }
  },
  CustomSettings: {
    ticketingSettings: {
      mandateCreationMedia: false,
      mandateCompletionMedia: false
    }
  },
  tenantPrompt: {
    show: false,
    landlordName: "",
    daysSinceExpiry: 0,
    message: ""
  }
};

let items = [];
const userReducer = (state = initialsState, action) => {
  switch (action.type) {
    case CREAT_USER_ACCOUNT_REQUEST:
    case UPDATE_USER_REQUEST:
    case INVITE_LANDLORD_REQUEST:
    case LOGIN_REQUEST:
    case FORGOT_PASSWORD_REQUEST:
    case VERIFY_FORGOT_TOKEN_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case SET_LOADING:
    case GET_ACCOUNT_DETAILS_REQUEST:
    case GET_SUBSCRIPTION_DETAILS_REQUEST:
    case GET_TICKETING_CUSTOM_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case VERIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
        step: action.payload?.step ?? 1,
        subStep: action.payload?.subStep ?? 0
      };
    case VERIFY_FORGOT_TOKEN_SUCCESS:
      return {
        ...state,
        isVerified: true,
        loading: false,
        tokenVerified: true
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPassword: true,
        loading: false
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotLinkSent: true,
        loading: false
      };
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false
      };
    case VERIFY_FORGOT_TOKEN_FAILURE:
      return {
        ...state,
        tokenVerified: false,
        loading: false
      };
    case CREAT_USER_ACCOUNT_SUCCESS:
    case LOGIN_SUCCESS:
      return {
        ...state,
        userData: {
          ...action.payload,
          userId: action.payload._id,
          landlordLogoImage: normalizeLandlordLogoImage(action.payload?.landlordLogoImage)
        },
        loading: false
      };
    case INVITE_LANDLORD_SUCCESS:
      localStorage.setItem("inviteSent", true);
      return {
        ...state,
        loading: false
      };
    case CREAT_USER_ACCOUNT_FAILURE:
    case UPDATE_USER_FAILURE:
    case INVITE_LANDLORD_FAILURE:
    case LOGIN_FAIL:
    case GET_ACCOUNT_DETAILS_FAILURE:
    case GET_SUBSCRIPTION_DETAILS_FAILURE:
      return {
        ...state,
        loading: false
      };
    case VERIFICATION_FAILURE:
      return {
        ...state,
        userData: { isProfileComplete: false },
        isVerified: false,
        step: action.payload?.step ?? 1,
        subStep: action.payload?.subStep ?? 0,
        loading: false
      };
    case VERIFICATION_SUCCESS:
      localStorage.setItem("isVerified", true);
      localStorage.setItem("role", action.payload.user.role);
      setUserDataInLocalStorage(action.payload.user);
      return {
        ...state,
        isVerified: true,
        userData: {
          ...action.payload.user,
          landlordLogoImage: normalizeLandlordLogoImage(action.payload.user?.landlordLogoImage)
        },
        step: action.payload?.step ?? 1,
        subStep: action.payload?.subStep ?? 0,
        loading: false
      };
    case SET_LANDLORD_LOGO_IMAGE: {
      const logo = normalizeLandlordLogoImage(action.payload);
      localStorage.setItem(Store.landlordLogoImage, logo);
      return {
        ...state,
        userData: { ...state.userData, landlordLogoImage: logo }
      };
    }
    case UPDATE_USER_SUCCESS: {
      const { step: nextStep, subStep: nextSubStep, ...userPayload } = action.payload || {};
      // Landlord holds no session at this point (see service/user.js updateUser() — the
      // response carries no token at all for Landlord) and the "review" screen is
      // transient: checking status later happens by actually logging in (Login.jsx's
      // ACTIVATION_PENDING flow), not by resuming persisted wizard state. So nothing about
      // this step gets written to localStorage for Landlord — only kept in memory for the
      // current tab. TradesPerson (and everyone else) still persists as before.
      if (userPayload.role !== Roles.Landlord) {
        localStorage.setItem("isProfileComplete", true);
        items = [
          { name: "step", value: nextStep ?? 2 },
          { name: "subStep", value: nextSubStep ?? 0 },
          { name: "showStepper", value: true }
        ];
        setItemsToLocalStorage(items);
        // Signup just completed — userPayload now carries a real jwtToken. Persist it as
        // the actual session.
        setUserDataInLocalStorage(userPayload);
      }
      const nextUser = { ...state.userData, ...userPayload };
      nextUser.landlordLogoImage = normalizeLandlordLogoImage(nextUser.landlordLogoImage);
      return {
        ...state,
        userData: nextUser,
        loading: false,
        step: nextStep ?? 2,
        subStep: nextSubStep ?? 0,
        isProfileComplete: true,
        showStepper: true
      };
    }
    case SET_USER_DATA:
      if (JSON.parse(localStorage.getItem("isProfileComplete")))
        action.payload.isProfileComplete = JSON.parse(localStorage.getItem("isProfileComplete"));
      return {
        ...state,
        userData: {
          ...action.payload,
          landlordLogoImage: normalizeLandlordLogoImage(action.payload?.landlordLogoImage)
        }
      };
    case SET_TICKET_TOKEN_USER_DATA:
      return {
        ...state,
        userData: action.payload
      };
    case SET_STEPS:
      items = [
        { name: "step", value: action.payload.step },
        { name: "subStep", value: action.payload.subStep },
        { name: "showStepper", value: action.payload.step !== 0 }
      ];
      setItemsToLocalStorage(items);
      return {
        ...state,
        step: action.payload.step,
        subStep: action.payload.subStep,
        showStepper: action.payload.step !== 0
      };
    case SET_SIGNUP_PAYLOAD:
      items = [{ name: "signupPayload", value: { ...state.signupPayload, ...action.payload } }];
      setItemsToLocalStorage(items);
      return {
        ...state,
        signupPayload: { ...state.signupPayload, ...action.payload }
      };
    case CLEAR_LOCALSTORAGE_SIGNUP_COMPLETE:
      items = ["isVerified", "subStep", "step", "signupPayload", "address", "showStepper"];
      removeItemsFromLocalStorage(items);
      return {
        userData: state.userData
      };
    case SET_USER_ROLE:
      return {
        ...state,
        signupPayload: { ...state.signupPayload, role: action.payload }
      };
    case SET_ADDRESSES:
      items = [{ name: "address", value: action.payload }];
      setItemsToLocalStorage(items);
      return {
        ...state,
        addresses: setAddressFormat(action.payload),
        loading: false
      };
    case RESEND_LINK:
      items = [{ name: "isResendLinkSent", value: true }];
      setItemsToLocalStorage(items);
      return {
        ...state,
        loading: false,
        isResendLinkSent: true
      };
    case SET_PROFILE_IMAGE:
      items = [{ name: "profileImage", value: action.payload.profileImage }];
      setItemsToLocalStorage(items);
      return {
        ...state,
        userData: { ...state.userData, profileImage: action.payload.profileImage },
        loading: false
      };
    case SET_MY_DETAILS:
      return {
        ...state,
        userData: (() => {
          const merged = {
            ...state.userData,
            ...action.payload,
            userId: action.payload._id || state.userData.userId,
            isLoggedIn: action.payload.isLoggedIn !== undefined ? action.payload.isLoggedIn : state.userData.isLoggedIn,
            isProfileComplete: action.payload.isProfileComplete !== undefined ? action.payload.isProfileComplete : state.userData.isProfileComplete,
            ...(state.userData.role === Roles.Tenant && {
              landlordBusinessName: state.userData.landlordBusinessName,
              landlordDisplayRole: state.userData.landlordDisplayRole
            })
          };
          merged.landlordLogoImage = normalizeLandlordLogoImage(merged.landlordLogoImage);
          return merged;
        })(),
        loading: false
      };
    case GET_ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        accountDetails: {
          contactDetails: action.payload.details.contactDetails,
          customDetails: action.payload.details.customDetails
        },
        loading: false
      };
    case GET_SUBSCRIPTION_DETAILS_SUCCESS:
      return {
        ...state,
        subscriptionDetails: action.payload,
        loading: false
      };
    case GET_TICKETING_CUSTOM_SETTINGS_SUCCESS:
      return {
        ...state,
        CustomSettings: {
          ...state.CustomSettings,
          ticketingSettings: action.payload.ticketingSettings
        },
        loading: false
      };
    case GET_TICKETING_CUSTOM_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false
      };
    case NEED_PASSWORD_CHANGE:
      return {
        ...state,
        liaisonFirstLogin: action.payload
      };
    case SET_CONTACT_DETAILS:
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          contactDetails: action.payload
        }
      };
    case SET_CUSTOM_DETAILS:
      if (action.payload.ticketingSettings) {
        return {
          ...state,
          CustomSettings: {
            ...state.CustomSettings,
            ticketingSettings: action.payload.ticketingSettings
          }
        };
      }
      return {
        ...state,
        accountDetails: {
          ...state.accountDetails,
          customDetails: action.payload
        }
      };
    case SHOW_TENANT_PROMPT:
      return {
        ...state,
        tenantPrompt: {
          show: true,
          landlordName: action.payload.landlordName,
          daysSinceExpiry: action.payload.daysSinceExpiry,
          message: action.payload.message
        }
      };
    case HIDE_TENANT_PROMPT:
      return {
        ...state,
        tenantPrompt: {
          show: false,
          landlordName: "",
          daysSinceExpiry: 0,
          message: ""
        }
      };
    case SIGNUP_INCOMPLETE:
      return { ...state, signupIncomplete: action.payload, loading: false };
    case CLEAR_SIGNUP_INCOMPLETE:
      return { ...state, signupIncomplete: { reason: null, userId: null, email: null, role: null, resumeToken: null } };
    default:
      return state;
  }
};

export default userReducer;
